import script from "./RedeemGiftView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RedeemGiftView.vue?vue&type=script&lang=ts&setup=true"

import "./RedeemGiftView.vue?vue&type=style&index=0&id=7ec6c913&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec6c913"]])

export default __exports__